import api from "../axios";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

export async function getNurses(for_assignment=false) {
  const tenant = getAccountId();
  const response = await api.get(
    `/accounts/${tenant}/nurses/`,
    {
      params: {
        "for_assignment": for_assignment,
      },
    }
  );
  return response.data;
}

export async function getStaff(role, position) {
  const tenant = getAccountId();
  const response = await api.get(
    `/accounts/${tenant}/staff-list-by-position/`,
    {
      params: {
        role,
        position,
      },
    }
  );
  return response.data;
}
